import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./routes/router";
import { AuthProvider } from "./lib/auth-provider";
import { ModeProvider } from "./lib/mode-provider";
import { ErrorBoundary } from "./components/error-boundary";
import { TooltipProvider } from "./components/ui/tooltip";
import "./globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <ModeProvider>
          <TooltipProvider delayDuration={150}>
            <RouterProvider router={router} />
          </TooltipProvider>
        </ModeProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
